module.exports = __webpack_public_path__ + "c4453a203a39acec756cad84ff6a0347.ico";